import { Routes, Route } from 'react-router-dom';
import Home from './pages/home/Index';
import AboutUs from './pages/aboutUs/Index';
import Planos from './pages/plans/Index';
import Solutions from './pages/solutions/Index';
import Niches from './pages/niches/Index';
import Login from './pages/login/Index';
import Register from './pages/register/Index';
import Cart from './pages/cart/Index';
import Checkout from './pages/checkout/Index';
import Perfil from './pages/perfil/Index';
import Dashboard from './pages/dashboard/Index';
import FaturasPendentes from './pages/dashboard/components/FaturasPendentes';
import PerfilDashboard from './pages/dashboard/components/PerfilDashboard';
import FaturasPagas from './pages/dashboard/components/FaturasPagas';
import Assinatura from './pages/dashboard/components/Assinatura';
import AssinarContrato from './pages/assinarContrato/Index';
import DetalhesCobranca from './pages/dashboard/components/DetalhesCobranca';
import ResetarSenha from './pages/resetarSenha/Index';
import MudarPlano from './pages/dashboard/components/MudarPlano';
import CancelarAssinatura from './pages/dashboard/components/CancelarAssinatura';
import Certificado from './pages/dashboard/components/Certificado';
import Servicos from './pages/dashboard/components/Servicos';
import NotasFiscaisEmitidas from './pages/dashboard/components/NotasFiscaisEmitidas';
import EmitirNotaServico from './pages/dashboard/components/EmitirNotaServico';
import PoliticaPrivacidade from './pages/politicaDePrivacidade/Index';
import TermosUso from './pages/termosDeUso/Index';
import MetodoPagamento from './pages/dashboard/components/MetodoPagamento';
import ApresentacaoContblack from './pages/apresentacaoContblack/ApresentacaoContblack';
import ApresentacaoEnderecoFiscal from './pages/dashboard/components/enderecoFiscal/ApresentacaoEnderecoFiscal';
import AssinarContratoEnderecoFiscal from './pages/dashboard/components/enderecoFiscal/AssinarContratoEnderecoFiscal';
import CheckoutEnderecoFiscal from './pages/dashboard/components/enderecoFiscal/CheckoutEnderecoFiscal';
import ResidenciaFiscal from './pages/dashboard/components/enderecoFiscal/ResidenciaFiscal';
import FichaCadastral from './pages/dashboard/components/FichaCadastral';
import Documentos from './pages/dashboard/components/Documentos';

import { UserProvider } from './contexts/UserContext';
import { DiscountProvider } from './contexts/DiscountContext';
import { LoginProvider } from './contexts/LoginContext';

import MetaTimeTracking from './hook/MetaTimeTracking';
import RiscosDeNaoDeclararOsImpostosDevidosOQuePodeAcontecerComVoce from './pages/blog/articles/RiscosDeNaoDeclararOsImpostosDevidosOQuePodeAcontecerComVoce';
import NuncaDeclareiImposto from './pages/blog/articles/NuncaDeclareiImposto';
import BeneficiosDeDeclararCorretamenteOsImpostos from './pages/blog/articles/BeneficiosDeDeclararCorretamenteOsImpostos';
import FreelancerPj from './pages/blog/articles/FreelancerPj';
import QuantoOCriadorDeConteudoRealmentePagaDeImposto from './pages/blog/articles/QuantoOCriadorDeConteudoRealmentePagaDeImposto';
import Blog from './pages/blog/Index';
import ModalTimer from './hook/ModalTimer';

function App() {
	return (
		<UserProvider>
			<DiscountProvider>
				<LoginProvider>
					<MetaTimeTracking />
					<ModalTimer />
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/SobreNos" element={<AboutUs />} />
						<Route path="/Planos" element={<Planos />} />
						<Route path="/Solucoes" element={<Solutions />} />
						<Route path="/Nichos" element={<Niches />} />
						<Route path="/Login" element={<Login />} />
						<Route path="/Cadastro" element={<Register />} />
						<Route path="/Carrinho" element={<Cart />} />
						<Route path="/Checkout" element={<Checkout />} />
						<Route path="/Perfil" element={<Perfil />} />
						<Route path="/AssinarContrato" element={<AssinarContrato />} />
						<Route path="/Dashboard" element={<Dashboard />} />
						<Route path="/Dashboard/Servicos" element={<Servicos />} />
						<Route path="/Dashboard/Faturas/Pendentes" element={<FaturasPendentes />} />
						<Route path="/Dashboard/Faturas/Pagas" element={<FaturasPagas />} />
						<Route path="/Dashboard/NotasFiscaisEmitidas" element={<NotasFiscaisEmitidas />} />
						<Route path="/Dashboard/EmitirNotaServico" element={<EmitirNotaServico />} />
						<Route path="/Dashboard/Perfil" element={<PerfilDashboard />} />
						<Route path="/Dashboard/Assinatura" element={<Assinatura />} />
						<Route path="/Dashboard/DetalhesCobranca" element={<DetalhesCobranca />} />
						<Route path="/Dashboard/alterarMetodoPagamento" element={<MetodoPagamento />} />
						<Route path="/Dashboard/MudarPlano" element={<MudarPlano />} />
						<Route path="/resetarSenha" element={<ResetarSenha />} />
						<Route path="/CancelarAssinatura" element={<CancelarAssinatura />} />
						<Route path="/Dashboard/Certificado" element={<Certificado />} />
						<Route path="/Dashboard/FichaCadastral" element={<FichaCadastral />} />
						<Route path="/Dashboard/Documentos" element={<Documentos />} />
						<Route path="/Dashboard/ApresentacaoEnderecoFiscal" element={<ApresentacaoEnderecoFiscal />} />
						<Route path="/Dashboard/AssinarContratoEnderecoFiscal" element={<AssinarContratoEnderecoFiscal />} />
						<Route path="/Dashboard/CheckoutEnderecoFiscal" element={<CheckoutEnderecoFiscal />} />
						<Route path="/Dashboard/ResidenciaFiscal" element={<ResidenciaFiscal />} />
						<Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
						<Route path="/termos-de-uso" element={<TermosUso />} />
						<Route path="/apresentacao-contblack" element={<ApresentacaoContblack />} />
						<Route path="/Blog" element={<Blog />} />
						<Route path="/Blog/riscos-de-nao-declarar-os-impostos-devidos-o-que-pode-acontecer-com-voce" element={<RiscosDeNaoDeclararOsImpostosDevidosOQuePodeAcontecerComVoce />} />
						<Route path="/Blog/nunca-declarei-imposto" element={<NuncaDeclareiImposto />} />
						<Route path="/Blog/beneficios-de-declarar-corretamente-os-impostos" element={<BeneficiosDeDeclararCorretamenteOsImpostos />} />
						<Route path="/Blog/freelancer-pj" element={<FreelancerPj />} />
						<Route path="/Blog/quanto-o-criador-de-conteudo-realmente-paga-de-imposto-e-como-pagar-menos-de-forma-legal" element={<QuantoOCriadorDeConteudoRealmentePagaDeImposto />} />
					</Routes>
				</LoginProvider>
			</DiscountProvider>
		</UserProvider>
	);
}

export default App;
